import { Component, Input, OnChanges } from '@angular/core';
import { EncSeries, Encoding } from '@mode-vegas/vegas';
import { SelectedChartService } from '@mode/charts/contract';
import { BinSizeTypes, ChartTypes, FlamingoTypes } from '@mode/shared/contract-common';
import { CompiledField } from '@mode/shared/util-switch';
import { ChannelSummary } from '../marks-helpers';
import { ChannelComponent } from './channel.component';

@Component({
  standalone: true,
  imports: [ChannelComponent],
  selector: 'mode-baseline-channel-component',
  templateUrl: './baseline-channel.component.html',
  styleUrls: ['./baseline-channel.component.scss'],
})
export class BaselineChannelComponent implements OnChanges {
  @Input({ required: true }) channelSummary!: ChannelSummary;
  @Input({ required: true }) encoding!: Encoding;
  @Input({ required: true }) model!: FlamingoTypes.ModeModel;
  @Input({ required: true }) view!: FlamingoTypes.ModeView;
  @Input({ required: true }) chartService!: SelectedChartService;
  @Input({ required: true }) chartType!: ChartTypes.ChartType;
  @Input() series: EncSeries | false = false;
  @Input({ required: true }) format!: ChartTypes.ChartFormat;
  @Input() queryToken: string | undefined;
  @Input() queryRunToken: string | undefined;
  @Input() vizToken: string | undefined;
  @Input() fieldFormatMap: ChartTypes.FieldFormatMap | undefined;
  @Input() binSizeToFieldMap: BinSizeTypes.BinSizeToFieldMap | undefined;

  allowScalars = true;

  ngOnChanges(): void {
    this.allowScalars = true;
    const field = this.channelSummary.field;
    if (field) {
      const compiled = CompiledField.fromEncField(this.view, field);
      this.allowScalars = compiled.isAttrDateType || compiled.isAttrNumberType;
    }
  }
}
